import { Lines, Fade } from "./Reveal";

export const Startup = () => (
  <section data-testid="startup-section" className="bg-[#F2F3F5] text-[#0D1B2A] py-28 md:py-44 px-6 md:px-10">
    <div className="grid grid-cols-12 gap-x-6 gap-y-16">
      <div className="col-span-12 md:col-span-7">
        <Lines lines={["Making expiration", "dates obsolete."]} className="display text-[2.6rem] sm:text-6xl lg:text-[5.4rem]" testId="startup-headline" />
      </div>
      <div className="col-span-12 md:col-span-5 md:col-start-7 lg:col-span-4 lg:col-start-8 md:mt-24">
        <Fade delay={0.2}>
          <p className="text-lg md:text-xl font-medium tracking-tight" data-testid="startup-copy-01">
            Telltag is a pre-commercial materials science company developing gas-reactive freshness indicators for meat
            packaging.
          </p>
          <p className="body-copy mt-8" data-testid="startup-copy-02">
            The indicator combines pH-sensitive dyes with nano-enabled sensing chemistry to quantify spoilage
            metabolites directly, replacing an elapsed-time estimate with a measurement of the food's actual condition.
            The objective is to substitute arbitrary printed dates with real-time biological data, reducing household
            food waste and improving food safety in the same step.
          </p>
          <p className="body-copy mt-6" data-testid="startup-copy-03">
            The product is not yet on the market. Telltag is raising its first funding round to build and test the
            first generation of prototypes.
          </p>
          <a href="#contact" className="inline-flex items-center gap-3 mt-8 py-3 eyebrow text-[#0D1B2A] underline underline-offset-4 decoration-[#0D1B2A]/30 hover:decoration-[#0D1B2A] transition-colors" data-testid="startup-investor-link">
            Investor and pilot enquiries
            <span aria-hidden>↓</span>
          </a>
        </Fade>
      </div>
    </div>
  </section>
);
